import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../auth/services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;

  constructor(private authService: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (this.authService.authenticated() && request.url.indexOf('/Users') === -1 && !request.headers.has('X-Skip-Interceptor')) {
      const authReq = request.clone({
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.authService.getToken(),
        })
      });
      return next.handle(authReq).pipe(
        catchError((error) => {
          if (error instanceof HttpErrorResponse && error.status === 401) {
            return this.handle401Error(authReq, next)
          }
          return throwError(() => [error, request]);
        })
      );
    } else {
      return next.handle(request);
    }
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;

        return this.authService.refreshSession().pipe(
          switchMap(() => {
            this.isRefreshing = false;

            request = request.clone({
              headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.authService.getToken()
              })
            });

            return next.handle(request);
          }),
          catchError((error) => {
            this.isRefreshing = false;

            console.log("401 interceptor");

            this.authService.logout();

            return throwError(() => error);
          })
        );
    }

    return next.handle(request);
  }
}
